import { render, staticRenderFns } from "./ReferenceManager.vue?vue&type=template&id=5ee8f04e&"
import script from "./ReferenceManager.vue?vue&type=script&lang=js&"
export * from "./ReferenceManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports